import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
interface PrivacyPageProps {
  onNavigate?: (path: string) => void;
}
export function PrivacyPage({
  onNavigate
}: PrivacyPageProps) {
  return <div className="min-h-screen bg-[#f5f5f7] text-[#1f2933]" data-id="element-1619">
      <Navbar onNavigate={onNavigate} data-id="element-1620" />

      <section className="py-24" data-id="element-1621">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8" data-id="element-1622">
          <h1 className="text-4xl font-bold mb-8" data-id="element-1623">Privacy Policy</h1>
          <p className="text-sm text-[#9ca3af] font-mono mb-12" data-id="element-1624">
            Last updated: {new Date().toLocaleDateString()}
          </p>

          <div className="space-y-8 bg-white border-2 border-dashed border-[#9ca3af] p-8" data-id="element-1625">
            <section data-id="element-1626">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1627">
                1. Information We Collect
              </h2>
              <p className="text-[#1f2933]/80 mb-4" data-id="element-1628">
                We collect information that you provide directly to us,
                including:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-[#1f2933]/80" data-id="element-1629">
                <li data-id="element-1630">Name and contact information (email, phone number)</li>
                <li data-id="element-1631">Payment information (processed securely through Selar)</li>
                <li data-id="element-1632">Profile information for accountability pods</li>
                <li data-id="element-1633">Content and communications within the program</li>
              </ul>
            </section>

            <section data-id="element-1634">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1635">
                2. How We Use Your Information
              </h2>
              <p className="text-[#1f2933]/80 mb-4" data-id="element-1636">
                We use the information we collect to:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-[#1f2933]/80" data-id="element-1637">
                <li data-id="element-1638">Provide and improve The Authority Engine program</li>
                <li data-id="element-1639">Process payments and manage your account</li>
                <li data-id="element-1640">Match you with appropriate accountability pods</li>
                <li data-id="element-1641">Send program updates and educational content</li>
                <li data-id="element-1642">Respond to your questions and support requests</li>
              </ul>
            </section>

            <section data-id="element-1643">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1644">
                3. Information Sharing
              </h2>
              <p className="text-[#1f2933]/80 mb-4" data-id="element-1645">
                We do not sell your personal information. We may share your
                information:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-[#1f2933]/80" data-id="element-1646">
                <li data-id="element-1647">
                  With your accountability pod members (name and relevant
                  profile information)
                </li>
                <li data-id="element-1648">
                  With service providers who assist in program delivery (e.g.,
                  payment processors)
                </li>
                <li data-id="element-1649">When required by law or to protect our rights</li>
              </ul>
            </section>

            <section data-id="element-1650">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1651">4. Data Security</h2>
              <p className="text-[#1f2933]/80" data-id="element-1652">
                We implement appropriate technical and organizational measures
                to protect your personal information. However, no method of
                transmission over the internet is 100% secure, and we cannot
                guarantee absolute security.
              </p>
            </section>

            <section data-id="element-1653">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1654">5. Your Rights</h2>
              <p className="text-[#1f2933]/80 mb-4" data-id="element-1655">You have the right to:</p>
              <ul className="list-disc pl-6 space-y-2 text-[#1f2933]/80" data-id="element-1656">
                <li data-id="element-1657">Access your personal information</li>
                <li data-id="element-1658">Correct inaccurate information</li>
                <li data-id="element-1659">
                  Request deletion of your information (subject to legal
                  obligations)
                </li>
                <li data-id="element-1660">Opt-out of marketing communications</li>
              </ul>
            </section>

            <section data-id="element-1661">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1662">
                6. Cookies and Tracking
              </h2>
              <p className="text-[#1f2933]/80" data-id="element-1663">
                We use cookies and similar tracking technologies to improve your
                experience and analyze program usage. You can control cookies
                through your browser settings.
              </p>
            </section>

            <section data-id="element-1664">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1665">
                7. Third-Party Services
              </h2>
              <p className="text-[#1f2933]/80" data-id="element-1666">
                We use third-party services including Selar (payments), WhatsApp
                (community), and Formspree (forms). These services have their
                own privacy policies governing the use of your information.
              </p>
            </section>

            <section data-id="element-1667">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1668">
                8. Changes to This Policy
              </h2>
              <p className="text-[#1f2933]/80" data-id="element-1669">
                We may update this Privacy Policy from time to time. We will
                notify you of significant changes by posting the new policy on
                this page and updating the "Last updated" date.
              </p>
            </section>

            <section data-id="element-1670">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1671">9. Contact Us</h2>
              <p className="text-[#1f2933]/80" data-id="element-1672">
                If you have questions about this Privacy Policy or our data
                practices, please contact us through our community WhatsApp
                group or email support.
              </p>
            </section>
          </div>
        </div>
      </section>

      <Footer onNavigate={onNavigate} data-id="element-1673" />
    </div>;
}